import { layoutRoute } from '@jeanologia/ng-layout/lib/layout-route.interface';

export class MenuRoutes {
  private menuRoutes: layoutRoute[];

  constructor(menuRoutes: layoutRoute[]) {
    this.menuRoutes = Array.from(menuRoutes);
  }

  getRoutes(): layoutRoute[] {
    return this.menuRoutes;
  }
}
